import * as yup from 'yup'
import formatters from './formatters'
import InputValidation from 'utils/InputValidation'

const fileListSchema = yup.mixed<FileList>()
  .required('O documento médico é obrigatório')
  .test('fileValidation', 'O arquivo deve ser PDF, JPG, JPEG ou PNG com no máximo 2MB', async (value: unknown): Promise<boolean> => {
    if (!value || !(value instanceof FileList) || value.length === 0) return false
    try {
      const validation = new InputValidation(value, 'imageOrPdf')
      const result = await validation.validate()
      return result.success
    } catch (error) {
      return false
    }
  })

export const medicalAppointmentSchema = yup.object({
  documentFile: fileListSchema,
  issueDate: yup.string()
    .required('A data de emissão é obrigatória')
    .test('valid-date', 'Digite uma data válida', value => {
      if (!value) return false
      return formatters.isValidDate(value)
    })
    .test('not-future', 'A data não pode ser maior que a data atual', value => {
      if (!value) return false
      return !formatters.isFutureDate(value)
    })
    .test('within-six-months', 'O pedido médico deve ter no máximo 6 meses', value => {
      if (!value) return false
      return formatters.isWithinValidPeriod(value)
    }),
  cid: yup.array().of(yup.object({
    id: yup.number().required('O CID é obrigatório'),
    name: yup.string().required('O CID é obrigatório'),
  })).min(1, 'O CID é obrigatório').required('O CID é obrigatório'),
  hasSessionQuantity: yup.string().optional(),
  sessionQuantity: yup.string().optional(),
  professionalName: yup.string().required('O nome do profissional é obrigatório'),
  specialty: yup.array().of(yup.object({
    id: yup.string().required('A especialidade é obrigatória'),
    name: yup.string().required('A especialidade é obrigatória'),
    type: yup.string(),
  })).min(1, 'A especialidade é obrigatória').required('A especialidade é obrigatória'),
  professionalDocumentNumber: yup.string().required('O documento do profissional é obrigatório'),
  professionalDocumentState: yup.array().of(yup.object({
    id: yup.string().required('O estado do documento é obrigatório'),
    name: yup.string().required('O estado do documento é obrigatório'),
  })).min(1, 'O estado do documento é obrigatório').required('O estado do documento é obrigatório'),
})

type InferredMedicalAppointmentFormData = yup.InferType<typeof medicalAppointmentSchema>

export interface MedicalAppointmentFormData extends Omit<InferredMedicalAppointmentFormData, 'documentFile'> {
  documentFile: FileList
}
